var BryanAnthonys = window.BryanAnthonys || {};
BryanAnthonys.cart = {
  cache: {},
  getCache: function () {
    return JSON.parse(JSON.stringify(BryanAnthonys.cart.cache));
  }
};
/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }
if ((typeof ba_essentials) === 'undefined') { ba_essentials = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/

ba_essentials.reportFailedCartOperation = function (operation, ajaxRequest, formOrData) {
  if (!ba_essentials.cart_reporting_url) {
    return;
  }
  var image_url = ba_essentials.cart_reporting_url + '?op=' + operation + '&st_code=' + ajaxRequest.status
  if (operation === 'add') {
    image_url += '&' + formOrData.serialize();
  } else if (operation === 'update' && formOrData) {
    var i = 0;
    for (var variant_key in formOrData) {
      image_url += '&items[' + i + '][id]=' + parseInt(variant_key.split(':')[0])
          + "&items[" + i + "][quantity]=" + parseInt(formOrData[variant_key]);
      i++;
    }
  } else if (operation === 'change' && formOrData) {
    image_url += '&line=' + formOrData[0] + '&quantity=' + formOrData[1];
  } else {
    image_url += '&' + jQuery.param(formOrData);
  }
  if (ajaxRequest.responseText) {
    image_url += '&responseText=' + ajaxRequest.responseText.substring(0, 255);
  }
  var img = document.createElement("img");
  document.querySelector('body').append(img);
  img.setAttribute("src", image_url);
  img.onload = function () {
    jQuery(img).remove();
    console.log('failed event sent to http log');
  }
  jQuery(img).css('opacity', 0);
  jQuery(img).css('width', '1px');
  jQuery(img).css('height', '1px');
};

ShopifyAPI.onCartUpdate = function (cart) {
  console.log('updated cart', cart);
};

ShopifyAPI.updateCartNote = function(note, callback, attributes) {
  var updateData = 'note=' + attributeToString(note);
  if (typeof attributes != 'undefined') {
    if ($.isArray(attributes)) {
      $.each(attributes, function (indexInArray, valueOfElement) {
        var key = attributeToString(valueOfElement.key);
        if (key !== '') {
          updateData += '&attributes[' + key + ']=' + attributeToString(valueOfElement.value);
        }
      });
    } else if ((typeof attributes === 'object') && attributes !== null) {
      $.each(attributes, function (key, value) {
        updateData += '&attributes[' + attributeToString(key) + ']=' + attributeToString(value);
      });
    }
  }
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: updateData,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description + '. Please refresh the page and try again.');
  }
};

ShopifyAPI.adjustMultiItemFormData = function (form) {
  var multiItemForm = jQuery(form).data('multi-items');
  var setUniqueId = jQuery(form).data('add-unique-setid');
  if (multiItemForm) {
    var unifiedQty = jQuery(form).find('[name="quantity"]').val();
    jQuery(form).find('temp-per-item-qty').remove();
    if (setUniqueId) {
      jQuery(form).find('temp-per-item-uniqid').remove();
      setUniqueId = (Math.random() * 1000).toFixed(0);
    }
    jQuery(form).find('[data-multi-item-add-index]').each(function () {
      var index = jQuery(this).data('multi-item-add-index');
      jQuery(this).before('<input type="hidden" name="items[' + index + '][quantity]" value="' + unifiedQty
          + '" class="temp-per-item-qty"/>');
      if (setUniqueId) {
        jQuery(this).before('<input type="hidden" name="items[' + index + '][properties][Set id]" value="' + setUniqueId
            + '" class="ttemp-per-item-uniqid"/>');
      }
    });
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {

  ShopifyAPI.adjustMultiItemFormData(form);

  var $body = $(document.body),

  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      if (typeof timber.changeNavTeaser === 'function' && typeof ba_js_trans === 'object') {
        setTimeout(function () {
          var bar_title = line_item.title || 'Items ';
          timber.changeNavTeaser(bar_title + ba_js_trans.item_added);
        }, 500);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ba_essentials.reportFailedCartOperation('add', XMLHttpRequest, jQuery(form));
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };

  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', {_: new Date().getTime()},  function (cart, textStatus) {
    ba_essentials.currentCart = cart;
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

ShopifyAPI.changeMultipleItems = function (data, successCallback, failCallback) {
  var $body = $(document.body);
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    beforeSend: function () {
      $body.trigger('beforeChangeItems.ajaxCart', data);
    },
    success: function (cart) {
      ba_essentials.currentCart = cart;
      if ((typeof successCallback) === 'function') {
        successCallback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItems.ajaxCart', [data, cart]);
      if (!cart.items.length) {
        ShopifyAPI.updateCartNote('');
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      if ((typeof failCallback) === 'function') {
        failCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      ba_essentials.reportFailedCartOperation('update', XMLHttpRequest, data.updates);
    },
    complete: function (jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback, failCallback) {
  var $body = $(document.body);
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      ba_essentials.currentCart = cart;
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      if (!cart.items.length) {
        ShopifyAPI.updateCartNote('', function(cart) {});
      }
      if (typeof timber.changeNavTeaser === 'function' && typeof ba_js_trans === 'object') {
        if (!quantity) {
          timber.changeNavTeaser(ba_js_trans.qty_changed_0);
        } else {
          timber.changeNavTeaser(ba_js_trans.qty_changed + quantity);
        }
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      if ((typeof failCallback) === 'function') {
        failCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      ba_essentials.reportFailedCartOperation('change', XMLHttpRequest, [line, quantity]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, cartUpdateCallback, setAddToCartCallback, openCollectionPopup;


  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, buildCart,
      cartCallback, adjustCart, adjustCartCallback, adjustCartErrorCallback, qtySelectors,
      validateQty, curateProductProps, updateGorgiasChatParams, prepareCustjScripts, getCustjButtonData,
      custjScriptsChecked = false, loadConditionalCartPlugins, initAdvancedUpsells,
      customAddToCartCallback = null, cartUpdateCallbackWithCustom, updateProductSetQuantity, showShippingInsurance,
      getPreorderHelper, trackEmptyCartOpen,
      prepareCustomFramesScripts, customFrameScriptsChecked = false, getCustomFrameButtonData, typesHiddenInCart = [],
      cartBubblesMarkup = '', cartCountdownMarkup = '', getCartOffersMarkup;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    if (settings.typesHiddenInCart) {
      typesHiddenInCart = settings.typesHiddenInCart.split(',');
    }

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();

    $(document).on('afterAddItem.ajaxCart', function() {
      if (typeof localStorage === 'undefined') {
        return;
      }
      localStorage.setItem('countdown_add_to_cart_timestamp', Math.round(new Date().getTime() / 1000));
    });
    $cartContainer.on('click', '.open-collection-popup-link', openCollectionPopup);
    $cartContainer.on('click', '[data-remove-ajc-item]', function () {
        $(this).closest('.ajaxcart__row').find('.ajaxcart__qty--minus').trigger('click');
    });

    $cartContainer.on('submit', 'form[action^="/cart"]', function() {
      var cartButton = $(this).find('button[name="checkout"], .btn-checkout-top-drawer');

      if (!cartButton.hasClass('ba-button--loading')) {
          cartButton.addClass('ba-button--loading');

          setTimeout(function() {
              cartButton.removeClass('ba-button--loading');
          }, 10000);
      }
    });

    $cartContainer.on('click', '.btn-checkout-top-drawer', function() {
      $cartContainer.find('button[name="checkout"]').click();
    });

    document.addEventListener('cartContentsChanged', function(event) {
      if (timber.RightDrawer.drawerIsOpen) {
        const cart = event.detail && event.detail.cart ? event.detail.cart : null;
        if (cart) {
          cartUpdateCallback(cart);
        } else {
          loadCart();
        }
      }
    });
  };

  loadCart = function () {
    if (typeof window.showAjaxCartAfterPayPresent === 'function') {
      window.showAjaxCartAfterPayPresent();
    }
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    const visibleItemsCount = cart.items.reduce(function (count, item) {
      return typesHiddenInCart.indexOf(item.product_type) === -1
          ? (item.quantity + count)
          : count;
    }, 0);
    if ($cartCountSelector) {
      $cartCountSelector.html(visibleItemsCount).removeClass('hidden-count');
      $cartCountSelector.parent().addClass('has-count');

      if (visibleItemsCount === 0) {
        $cartCountSelector.addClass('hidden-count');
        $cartCountSelector.parent().removeClass('has-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      if ($formContainer.hasClass('disable-default-ajax-cart-listener')) {
        // add the ability to skip the default submit listener when creating a separate handler
        if ($formContainer.hasClass('prevent-default-browser-submit')) {
          evt.preventDefault();
        }
        return;
      }

      evt.preventDefault();

      window.itemAddToCartFromMainForm = true;

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    if (customAddToCartCallback) {
      ShopifyAPI.getCart(cartUpdateCallbackWithCustom);
    } else {
      ShopifyAPI.getCart(cartUpdateCallback);
    }
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (data && data.message && data.status === 422) {
      $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>');
    } else {
      $formContainer.after('<div class="errors qty-error">An error occurred. Please try refreshing the page!</div>');
    }
  };

  cartUpdateCallbackWithCustom = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    customAddToCartCallback(cart);
    updateGorgiasChatParams(cart);
  }

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
    updateGorgiasChatParams(cart);
  };

  updateGorgiasChatParams = function(cart) {
    try {
      if (typeof window.GorgiasChat === "object"
          && typeof window.GorgiasChat.captureShopifyCart === "function"
      ) {
        window.GorgiasChat.captureShopifyCart(cart);
        console.log('Gorgias cart updated');
      }
    } catch (e) {
      console.log('Gorgias cart failed');
      return false;
    }
  }

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();
    isUpdating = false;

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.parent().addClass('has-nothing-in');

      var emptyCartHtml = ($('#EmptyCartDrawerTemplate').html() || '').trim()
      if (emptyCartHtml && emptyCartHtml.indexOf('empty-cart-drawer__header') > 0) {
        $cartContainer.append(emptyCartHtml);
        $('.empty-cart-drawer').fadeIn(500);
      } else {
          $cartContainer
              .append('<div style="padding: 15px;"><p class="empty-cart-p">' + ba_js_trans.cart_empty_text
                  + '</p><div class="continue-shopping"><button type="button" onclick="timber.RightDrawer.close();" '
                  + ' class="ba-button ba-button--w100 ba-button--small ba-button--checkout" name="continue_shopping">'
                  + '<span>' + ba_js_trans.continue_shopping_btn + '</span></button></div></div>');
      }
      cartCallback(cart);
      trackEmptyCartOpen();
      return;
    } else {
      $cartContainer.parent().removeClass('has-nothing-in');
      $cartContainer.append('<div style="padding: 15px;" class="aj-cart-loading-placeholder"><p class="empty-cart-p">'
          + 'Your Cart is loading...</p><div class="continue-shopping"><a href="/cart" class="ba-button ba-button--w100'
          + ' ba-button--white ba-button--small ba-button--checkout"><span>View cart page</span></a></div></div>');
    }

    BryanAnthonys.cart.cache = cart;
    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source),
        extraNote = [],
        incart_variant_ids = [],
        incart_product_ids = [];

    // Add each item to our handlebars.js data
    var cartHasCanvasItems = false;
    var hasOnlyCanvas = true;
    var preorderHelper = getPreorderHelper();
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      var prodImg;
      if (cartItem.image != null){
        var image_size = cartItem.handle === 'skip-the-line' ? "_200x60_crop_center$1" : "_250x$1";
        prodImg = cartItem.image.replace(/(\.[^.]*)$/, image_size).replace('http:', '');
        if (cartItem.handle === 'skip-the-line' && window.cartDrawerUpsaleConfig
            && window.cartDrawerUpsaleConfig.skip_the_line_image) {
          prodImg = window.cartDrawerUpsaleConfig.skip_the_line_image;
        }
      } else {
        prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var isItemOnBackOrder = preorderHelper.isItemOnBackOrder(cartItem);
      if (isItemOnBackOrder) {
        extraNote.push(cartItem.sku);
      }

      if (cartItem.sku && cartItem.sku.indexOf('BA-CANV') === 0) {
        cartHasCanvasItems = true;
      } else if (cartItem.sku && cartItem.sku.indexOf('BA-SHIP-PROTECT') === -1) {
        hasOnlyCanvas = false;
      }

      var curatedProps = curateProductProps(cartItem);
      var customProductButton = null;
      if (curatedProps && ('Compass' in curatedProps || 'Engraving' in curatedProps)) {
        prepareCustjScripts();
        customProductButton = getCustjButtonData(cartItem, curatedProps);
      }
      if (curatedProps && 'Your Canvas Image' in curatedProps) {
        prepareCustomFramesScripts();
        customProductButton = getCustomFrameButtonData(cartItem, curatedProps);
      }
      if (window.current_shop_currency && window.current_shop_currency === 'USD') {
        if (cartItem.original_price === cartItem.final_price) {
          if (window.cartCompareAtPrices[cartItem.variant_id]
              && window.cartCompareAtPrices[cartItem.variant_id] > cartItem.final_price) {
            cartItem.original_price =  window.cartCompareAtPrices[cartItem.variant_id];
            cartItem.original_line_price = cartItem.original_price * cartItem.quantity;
            // if (!cartItem.discounts.length) {
            //   var special_discount = cartItem.original_line_price - cartItem.line_price;
            //   cartItem.discounts.push({
            //     amount: special_discount,
            //     title: 'Limited time offer'
            //   });
            //   cart.total_discount += special_discount;
            // }
          }
        }
      }

      var itemDiscountsAdjusted = [];
      for (var discountIndex = 0; discountIndex < cartItem.discounts.length; discountIndex++) {
        var discount = cartItem.discounts[discountIndex];
        var discountTitle = cartItem.discounts[discountIndex].title;
        if (discountTitle.indexOf('Bundle') !== -1) {
          var discountTitleParts = discountTitle.split(' Bundle ');
          if (discountTitleParts.length === 2 && discountTitleParts[1].indexOf('%Off') !== -1) {
            discountTitle = 'Bundle ' + discountTitleParts[1].replace('%Off', '% off');
          }
        }
        itemDiscountsAdjusted.push({
          amount: discount.amount,
          title: discountTitle
        });
      }

      if (cartItem.sku === 'BA-CARD-ISLE-GREET-CARD' && cartItem.properties && cartItem.properties['Card Isle Print Code']) {
        var pickuCode = cartItem.properties['Card Isle Print Code'].replace(/[^a-z0-9]/gi, '');
        prodImg = 'https://www.cardisle.com/api/partner/get-cover-image/?pickup_code=' + pickuCode;
      }

      var is_insurance = typeof window.ba_shipping_insurance_config === 'object'
          && window.ba_shipping_insurance_config.variant_ids
          && window.ba_shipping_insurance_config.variant_ids.indexOf(cartItem.variant_id) > -1;
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        variant_id: cartItem.variant_id,
        product_id: cartItem.product_id,
        properties: curatedProps,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.final_price, settings.moneyFormat),
        priceCents: cartItem.final_price,
        originalPrice: Shopify.formatMoney(cartItem.original_price, settings.moneyFormat),
        originalPriceCents: cartItem.original_price,
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: itemDiscountsAdjusted,
        discountsApplied: !(cartItem.line_price === cartItem.original_line_price),
        customProductButton: customProductButton,
        part_of_set_id: cartItem.part_of_set_id || '',
        is_insurance: is_insurance,
        handle: cartItem.handle,
        is_free_gift: cartItem.properties && cartItem.properties['Free gift'] && cartItem.properties['Free gift'] === 'Yes'
      };
      items.push(item);
      incart_variant_ids.push(cartItem.variant_id);
      incart_product_ids.push(cartItem.product_id);
    });

    // Gather all cart data and add to DOM

    var free_shipping_threshold = parseFloat(ba_essentials ? ba_essentials.free_shipping_value : 75) * 100;
    var real_cart_total = cart.total_price;
    var needed_total = free_shipping_threshold - real_cart_total;

    if (needed_total > 0) {
      var onlyCanvases = true;
      $.each(cart.items, function(index, cartItem) {
        if (cartItem.product_type !== 'Canvases') {
          onlyCanvases = false;
        }
      });
      if (onlyCanvases) {
        needed_total = 0;
      }
    }

    var shipping_teaser_text;

    if (needed_total <= 0) {
      shipping_teaser_text = '<span class="isReady"><span class="icon icon-checkmark2" aria-hidden="true"></span> '
              + ba_js_trans.free_shipping_earned +
              '<span class="free_progress"><span style="width: 100%"></span></span></span>';
    } else {
      shipping_teaser_text = '<span class="notReady">'
              + ba_js_trans.free_shipping_teaser.replace('[amount]', '<span class="money">' +
                      Shopify.formatMoney(needed_total, settings.moneyFormat) + '</span>').replace('.00', '') +
              '<span class="free_progress"><span style="width: ' + Math.round((real_cart_total / free_shipping_threshold) * 100)
              + '%"></span></span></span>';
    }

    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      originalTotalPrice: cart.original_total_price > cart.total_price
        ? Shopify.formatMoney(cart.original_total_price, settings.moneyFormat)
        : null,
      totalCartDiscount: cart.total_discount === 0 ? 0 : ba_js_trans.yousave_text.replace('[savings]', '-'
              + Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0,
      displayCheckoutButOnTop: items.length > 2 ,
      shipping_teaser_text: shipping_teaser_text,
      notOnlyCanvas: !hasOnlyCanvas,
      cartOffersMarkup: getCartOffersMarkup()
    }
    $cartContainer.find('.aj-cart-loading-placeholder').remove();
    $cartContainer.prepend(template(data));

    //advanced upsells
    initAdvancedUpsells(cart);

    if (preorderHelper.shouldWriteNote) {
      preorderHelper.writeComment(extraNote, '#CartSpecialInstructions', 'ajaxCart');
    } else if (preorderHelper.shouldWriteAttributes) {
      var hasBackOrderItems = extraNote.length > 0;
      if (
          (!hasBackOrderItems && typeof cart.attributes[preorderHelper.cartAttributeNameForPreorders] != "undefined")
              || (hasBackOrderItems && typeof cart.attributes[preorderHelper.cartAttributeNameForPreorders] == "undefined")
      ) {
        preorderHelper.writeCartAttribute(hasBackOrderItems, 'ajaxCart');
      }
    }
    cartCallback(cart);
    loadConditionalCartPlugins();
    //shipping insurance
    showShippingInsurance(cart);
  };

  curateProductProps = function(cartItem) {
    if (!cartItem.properties) {
      return null;
    }
    var properties = {};
    for (var prop in cartItem.properties) {
      if (prop === 'Set id') {
        cartItem.part_of_set_id = cartItem.properties[prop];
        continue;
      }
      if (prop === '_Special Offer' && (cartItem.properties[prop] === 'Yes' || cartItem.properties[prop] === 'Sale')) {
        continue;
      }
      if (prop === '_bundle_PDP' || prop === '_bundle_Popup' || prop === '_letterHeight' || prop === '_engravingPreview' || prop === 'Card Isle Print Code') {
        continue;
      }
      properties[prop] = cartItem.properties[prop];
    }
    return properties;
  }

  prepareCustjScripts = function() {
    if (custjScriptsChecked) {
      return;
    }
    if (window.customJewelryConfig && window.customJewelryConfig.custjScriptUrl) {
      timber.checkAndAddScript(window.customJewelryConfig.custjScriptUrl);
    }
    if (window.magnificPopupJsUrl) {
      timber.checkAndAddScript(window.magnificPopupJsUrl);
    }
    if (window.magnificPopupCssUrl) {
      timber.checkAndAddStyle(window.magnificPopupCssUrl);
    }
    custjScriptsChecked = true;
  }

  prepareCustomFramesScripts = function () {
    if (customFrameScriptsChecked) {
      return;
    }

    if (ba_essentials.frame_builder_preview_js_url) {
      timber.checkAndAddScript(ba_essentials.frame_builder_preview_js_url);
    }

    if (ba_essentials.ba_quick_popup_js_url) {
      timber.checkAndAddScript(ba_essentials.ba_quick_popup_js_url);
    }

    customFrameScriptsChecked = true;
  }

  getCustjButtonData = function (cartItem, curatedProps) {
    var finish = '14k-gold';
    if (cartItem.variant_options.length) {
      finish = cartItem.variant_options[0].toLowerCase().replace(' ', '-');
    }

    // TODO find a better way yo do this without repeating ourselves
    let previewImage = '';
    for (const prop in cartItem.properties) {
      if (prop === '_engravingPreview') {
        previewImage = cartItem.properties[prop];
        break;
      }
    }

    return {
      initials: curatedProps['Compass'] || '',
      engraving: curatedProps['Engraving'] || '',
      handle: cartItem.handle,
      finish: finish,
      image: previewImage,
      css_class: 'custom-jewelry-preview can-show-animation',
      text: ba_js_trans.preview
    }
  }

  getCustomFrameButtonData = function (cartItem, curatedProps) {
    return {
      image: curatedProps['Your Canvas Image'],
      handle: cartItem.handle,
      variant_title: cartItem.variant_title,
      css_class: 'product-frame-builder-preview can-show-animation',
      text: 'Preview Your Frame'
    }
  }

  getCartOffersMarkup = function () {
    if (!cartBubblesMarkup) {
      const template = document.getElementById('CartOfferBubbleTemplate');
      if (template) {
        cartBubblesMarkup = template.innerHTML;
      }
    }

    if (!cartCountdownMarkup) {
      const template = document.getElementById('CartOfferCountdownTemplate');
      if (template) {
        cartCountdownMarkup = template.innerHTML;
      }
    }

    const markup = cartBubblesMarkup + cartCountdownMarkup;

    return markup
        ? '<div class="cart-drawer-offers">' + markup + '</div>'
        : '';
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
        setTimeout(function () {
          //unlocking it in case it got stuck somehow
          isUpdating = false;
        }, 1000);
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if ($row.parent().parent().hasClass('lock-quantity-change')) {
        isUpdating = false;
        console.log('not allowing second remove');
        return;
      }

      if (
          window.cartDrawerUpsaleConfig
          && window.cartDrawerUpsaleConfig.products_limited_to_1
          && window.cartDrawerUpsaleConfig.products_limited_to_1.indexOf($row.data('variantid')) !== -1
          && qty > 1
      ) {
        qty = 1;
      }

      var set_id = $row.data('set-id');
      if (set_id) {
        updateProductSetQuantity(set_id, qty);
        return;
      }

      if (qty === 0) {
        $row.parent().addClass('is-removed');
        $row.parent().parent().addClass('lock-quantity-change');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback, adjustCartErrorCallback);
      }, 50);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote);
    });
  };

  updateProductSetQuantity = function (set_id, qty) {
    var setItems = $cartContainer.find('[data-set-id="' + set_id + '"]');
    var updates = {};
    var found = 0;
    setItems.each(function () {
      var lineItemKey = $(this).find('.ajaxcart__qty-num').data('id');
      if (lineItemKey) {
        updates[lineItemKey] = qty;
        found++;
      }
    });
    if (!found) {
      console.error('no items found in set' + set_id);
      isUpdating = false;
      return;
    }
    ShopifyAPI.changeMultipleItems({updates: updates}, adjustCartCallback, adjustCartErrorCallback);
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    isUpdating = false;
    buildCart(cart);
  };

  adjustCartErrorCallback = function (XMLHttpRequest, textStatus) {
    isUpdating = false;
    ShopifyAPI.getCart(cartUpdateCallback);
    if (XMLHttpRequest.responseText) {
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description + '. Please refresh the page and try again.');
      }
    } else {
      alert('An error occured');
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"].cartpage-set-quantity, input[type="number"]#Quantity');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id'),
            setId = $el.data('cartpage-set-id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        var $elParent = $el.parent();
        $el.after(template(data)).remove();
        if (setId) {
          $elParent.find('.js-qty__num').attr('data-cartpage-set-id', setId);
          $elParent.find('.js-qty__num').on('change', function() {
            $('[data-cartpage-set-id="' + setId + '"]').val($(this).val());
          });
        }
      });

      //Update product page price
      $('.product-qty-and-add-button').find('.js-qty__num').on('change', function () {
        var priceEl = $('#ProductPrice');
        var productEarnedPoints = $('#PointsEarnedForProduct');
        var currentProductPrice = priceEl.attr('content');
        if (currentProductPrice) {
          currentProductPrice *= parseInt($(this).val()) * 100;
          priceEl.html('<span  class="money">'
              + Shopify.formatMoney((priceEl.attr('content') * 100), settings.moneyFormat).replace('.00', '')
              + '</span>');
          productEarnedPoints.text(Math.round(currentProductPrice / 100));
        }
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty).trigger('change');
      });

      $('#Quantity').on('change', function () {
        document.dispatchEvent(new CustomEvent('pdpQuantityChanged', {
          detail: {quantity: $(this).val()}
        }));
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      return qty;
    } else {
      return 1
    }
  };

  loadConditionalCartPlugins = function () {
    if (window.baCartCountdownACStatus) {
      if (!window.baCartCountdownLoaded && ba_essentials.cart_countdown_url) {
        ba_essentials.loadScript(ba_essentials.cart_countdown_url).done(function( script, textStatus ) {
          baCartCountdown.showCountDown('ajax_cart');
        });
      } else if (window.baCartCountdownLoaded) {
        baCartCountdown.showCountDown('ajax_cart');
      }
    }
  };

  initAdvancedUpsells = function (cart) {
    if (typeof window.cartDrawerUpsaleConfig !== 'object') {
      return;
    }
    if (!window.baAdvancedUpsellsLoaded && window.cartDrawerUpsaleConfig.script_url) {
      ba_essentials.loadScript(window.cartDrawerUpsaleConfig.script_url).done(function (script, textStatus) {
        try {
          baAdvancedUpsells.showCartUpsells(cart, $cartContainer);
        } catch (e) {
          console.error(e);
        }
      });
    } else if (window.baAdvancedUpsellsLoaded) {
      try {
        baAdvancedUpsells.showCartUpsells(cart, $cartContainer);
      } catch (e) {
        console.error(e);
      }
    }
  }

  showShippingInsurance = function (cart) {
    if (typeof window.ba_shipping_insurance_config !== 'object') {
      return;
    }
    if (typeof window.ba_shipping_insurance === 'undefined') {
      ba_essentials.loadScript(window.ba_shipping_insurance_config.script_url).done(function (script, textStatus) {
        try {
          window.ba_shipping_insurance.showInsuranceInDrawer(cart, $cartContainer);
        } catch (e) {
          console.error(e);
        }
      });
    } else {
      try {
        window.ba_shipping_insurance.showInsuranceInDrawer(cart, $cartContainer);
      } catch (e) {
        console.error(e);
      }
    }
  };

  setAddToCartCallback = function (callback) {
    customAddToCartCallback = callback;
  }

  openCollectionPopup = function(event) {
    if (typeof popupCollectionSlider !== 'object') {
      return
    }
    event.preventDefault();
    var link = $(this);
    var collection = link.data('collection');
    if (link.hasClass('is-opening') || !collection) {
      return;
    }
    link.addClass('is-opening');
    if (typeof popupCollectionSlider !== 'object') {
        //in the future make this load
    } else {
        popupCollectionSlider.openCollectionPopupLink(collection);
    }
    setTimeout(function() {
      link.removeClass('is-opening');
    }, 15000);
  }

  getPreorderHelper = function () {
    return window.preorderHelper || {
      isItemOnBackOrder: function () {
      }
    }
  }

  trackEmptyCartOpen = function () {
    if (typeof ga !== 'function') {
      return;
    }
    ga('send', {
      hitType: 'event',
      eventCategory: 'AjaxCart',
      eventAction: 'AjaxCartOpen',
      eventLabel: 'AjaxCartOpenEmpty',
      eventValue: 1
    });
  }

  module = {
    init: init,
    load: loadCart,
    cartUpdateCallback: cartUpdateCallback,
    setAddToCartCallback: setAddToCartCallback,
    openCollectionPopup: openCollectionPopup
  };

  return module;

}(ajaxCart || {}, jQuery));
